import {Acceptance, RequestState} from "../types/ApiTypes";
import {CgCheckO, CgSpinner} from "react-icons/cg";
import {FaTimesCircle} from "react-icons/fa";

export const humanSpaceState = (state: RequestState) => {
    switch (state) {
        case RequestState.AwaitsAcceptance: return 'Erwartet Bestätigung';
        case RequestState.Running: return 'Läuft';
        case RequestState.Completed: return 'Abgeschlossen';
        case RequestState.Failed: return 'Fehlgeschlagen';
        default: return 'Unexpected state';
    }
}

export const humanAcceptanceState = (state: Acceptance) => {
    switch (state) {
        case Acceptance.Accepted: return <span className='flex items-center'><CgCheckO className='text-success-darker mr-1'/> Bestätigt</span>;
        case Acceptance.Declined: return <span className='flex items-center'><FaTimesCircle className='text-error-brighter mr-1'/> Abgelehnt</span>;
        case Acceptance.NoAction: return <span className='flex items-center'><CgSpinner className='animate-spin mr-1'/> Läuft...</span>;
        default: return 'Unexpected state';
    }
}

export const nl2br = (text: string) => text.split('\n').map(item => <>{item}<br/></>);